import { useState, useEffect } from "react";
import * as convert from "../constant/Convert.helper";
import axiosService from "../../utils/axios.service";
import { TimePicker, Spin } from 'antd';
import { format } from "date-fns";
import { notifications } from "../constant/Notify";
import Item  from "./Item"
import _ from "lodash"

const PagePancake = () => {
    const [pagePancake, setPagePancake] = useState([])
    const [displayDetail, setDisplayDetail] = useState(false)
    const [displayDel, setDisplayDel] = useState(false)
    const [dataCurrentPage, setDataCurrentPage] = useState(null)
    const [loading, setLoading] = useState(true);

    const userAdmin = JSON.parse(localStorage.getItem("user_info"))

    useEffect(async () => {
        const fetchData = async () => {
            try {
                const res = await axiosService("api/sale/online-v2/page-pancake/get-all", "GET");
                if (res?.data?.success) {
                    setPagePancake(res.data.data || []);
                } else {
                    notifications({type: "error", mess: res?.data?.message ?? "Không thể cập nhật dữ liệu"});
                }
            } catch (error) {
                notifications({type: "error", mess: "Không thể lấy dữ liệu"});
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [])

    if (!userAdmin || ![107, 81].includes(Number(userAdmin.id))) return null;

    const saveData = async (payload) => {
        setLoading(true)
        try {
            const res = await axiosService("api/sale/online-v2/page-pancake/save", "POST", payload);
            if (res?.data?.success) {
                const item = res.data.data;

                setPagePancake((prev) => {
                    const exists = prev.some((page) => page.id === item.id);
                    if (exists) {
                        return prev.map((page) =>
                            page.id === item.id ? item : page
                        );
                    }
                    return [item, ...prev];
                });
                setDisplayDetail(false)
                notifications({type: "success", mess: "Thành công"});
            } else {
                notifications({type: "error", mess: res?.data?.message ?? "Không thể cập nhật dữ liệu"});
            }
        } catch (error) {
            notifications({type: "error", mess: "Không thể cập nhật dữ liệu"});
        } finally {
            setLoading(false);
        }
    }

    const syncTags = async (id) => {
        setLoading(true)
        try {
            const res = await axiosService(`api/sale/online-v2/page-pancake/sync-tag/${id}` , "GET");
            if (res?.data?.success) {
                const tags = res.data.data;
                setPagePancake(prev => prev.map(item => item.id === id ? { ...item, tags: tags } : item));
                notifications({type: "success", mess: "Cập nhật tags thành công"});
            } else {
                notifications({type: "error", mess: res?.data?.message ?? "Không thể cập nhật tags"});
            }
        } catch (error) {
            notifications({type: "error", mess: "Không thể cập nhật tags"});
        } finally {
            setLoading(false);
        }
    }

    return (
        <Spin spinning={loading} size="large" tip="Đang tải...">
            <div className="admin-page stores">
            <div className="page-title">
                <div className="title-page">
                    <i className="fas fa-map-marker-alt"></i> Quản lý page Pancake
                </div>
                <div className="button-cent" onClick={() => {setDisplayDetail(true)}}>
                    <span><i className="fas fa-map-marker-alt"></i></span> Thêm page
                </div>
            </div>
            <div className="admin-body">
                {pagePancake.length > 0 ? 
                <div className="dashboard-content">
                    <div className="wrapper">
                        {pagePancake.map((val, key) => (
                            <div className="item-store" key={key}>
                                <h3 className="title-store">{val.name}</h3>
                                <p className="info-store">
                                    <strong className="label">Id page: </strong>
                                    <span className="value">{val.page_id}</span>
                                </p>
                                <p className="info-store">
                                    <strong className="label">Số lượng tags: </strong>
                                    <span className="value">{val?.tags?.length ?? 0}</span>
                                </p>
                                {val?.update_tag ?
                                    <p className="info-store">
                                        <strong className="label">Ngày cập nhật tags: </strong>
                                        <span className="value">{format(new Date(val?.update_tag), "yyyy-MM-dd HH:mm:ss")}</span>
                                    </p>
                                : null}
                                
                                <div className="button-container">
                                    <div className="button-cent style5" onClick={() => {syncTags(val.id)}}>
                                        <span><i className="fas fa-sync"></i></span>Update tags
                                    </div>
                                    <div className="button-cent" onClick={() => {setDisplayDetail(true); setDataCurrentPage(val)}}>
                                        <span><i className="fas fa-pen"></i></span>Sửa
                                    </div>
                                    <div className="button-cent style3" onClick={() => {setDisplayDel(true); setDataCurrentPage(val)}}>
                                        <span><i className="fas fa-trash-alt"></i></span>Xóa
                                    </div>
                                </div>
                            </div>             
                        ))}
                    </div>
                </div>
                : null}
                {displayDetail ? 
                    <Item data={dataCurrentPage} displayPopup={setDisplayDetail} saveData={saveData} />
                : null}
            </div>
            </div>
        </Spin>
    );
};

export default PagePancake;

